import { createApiHook, useApi } from "../utils/apiUtils";

const useUpdateQuestion = () => {
  const { apiPatch } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const updateQuestion = async (id, payload) => {
    startLoading();
    const response = await apiPatch(`/questions/${id}`, "Error al actualizar la pregunta", payload);
    setResponse(response);

    if (response?.error) {
      const err = new Error(response.error.message || "No se pudo actualizar la pregunta");
      err.backend = response.error;
      throw err;
    }

    return response;
  };

  return { updateQuestion, data, loading, error };
};

export default useUpdateQuestion;
